import { Profile } from "../shared/profile.model";
import { Discussion } from "./discussion.model";

export class DiscussionBookmark {
  id: string;
  discussion: Discussion;
  owner: Profile;
  createdAt: string;
  updatedAt: string;
}
